export const EnglishTranslations = {
  
}
